import { Injectable, inject } from '@angular/core';
import { Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FormKeys } from '@nx-customer-apps/shared/enums';
import { FormOptions } from '@nx-customer-apps/shared/interfaces';
import { SliderQuestion } from '@nx-customer-apps/shared/utils';
import { BuildingType } from '@nx-customer-apps/components';

@Injectable({
    providedIn: 'root'
})
export class LivingAreaFormService {
    private translateService = inject(TranslateService);

    public getLivingAreaQuestions(options: FormOptions): SliderQuestion[] {
        const livingArea = this.getLivingArea(options);
        return [livingArea];
    }

    private getLivingArea(options: FormOptions): SliderQuestion {
        if (!options.buildingType) {
            throw Error('Please specify buildingType for livingArea question.');
        }
        const settings = {
            [BuildingType.MultiFamilyHouse]: { min: 200, max: 99999 },
            [BuildingType.SingleFamilyHouse]: { min: 100, max: 450 }
        };
        const selectedSettings = settings[options.buildingType];
        const question = this.translateService.instant('HEATLOAD.LIVING_AREA.SLIDER_DESCRIPTION', selectedSettings);
        return new SliderQuestion({
            styles: 'ca-living-area-slider',
            question,
            placeholder: 'HEATLOAD.LIVING_AREA.SLIDER_PLACEHOLDER',
            key: FormKeys.LivingArea,
            validators: [Validators.required],
            min: selectedSettings.min,
            max: selectedSettings.max,
            suffix: 'MEASUREMENT_UNITS.M2',
            value: options?.questions?.[FormKeys.LivingArea]?.value || ''
        });
    }
}
